import Logout from './container';
export default Logout;
